import Vue from 'vue';

export default class ToastUtils {
  constructor(toastOptions) {
    if (!toastOptions) {
      return;
    }

    this.messages = {
      success: toastOptions.subject ? `${toastOptions.subject} ${Vue.i18n.t('app.hasBeenUpdated')}.` : toastOptions.success,
      error: toastOptions.subject ? `${Vue.i18n.t('app.errorOnUpdate')} ${toastOptions.subject.toLowerCase()}!` : toastOptions.error,
      loading: toastOptions.loading || toastOptions.subject,
    };
    this.position = toastOptions.position || 'top-right';
  }

  show(type, defaultMsg) {
    if (!this.messages) {
      return null;
    }
    const msg = this.messages[type] || defaultMsg || type;
    return ToastUtils.showToast(type, msg, this.position);
  }

  static getToastConfig(type, position = 'top-right') {
    const config = {
      loading: {
        type: 'info',
        duration: null,
        className: 'spinner',
        position,
      },
      warning: {
        type: 'info',
        duration: 6000,
        position,
      },
      success: { type: 'success', duration: 2000, position },
      error: { type: 'error', duration: 4000, position },
    };
    return config[type];
  }

  static showToast(type, msg, position = 'top-right') {
    const toastConfig = ToastUtils.getToastConfig(type, position);
    return Vue.toasted.show(msg || `${Vue.i18n.t('app.processing')}...`, toastConfig);
  }

}



// WEBPACK FOOTER //
// ./src/utils/toast.js